module.exports = "textarea {\n  min-height: 80px;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/abastecimentos/locais/local-form/local-form.component.css
 ** module id = 551
 ** module chunks = 0
 **/